import {Box} from "@material-ui/core";
import Typography from "@mui/material/Typography";
import React from "react";

const AhtapotTextBox = () => {
    return <Box style={{paddingLeft: 10, marginTop: 10, fontsize: 8}}
                maxWidth="md"
                fullWidth>
        <Typography component="div" gutterBottom style={{fontsize: 8, fontWeight: "bolder"}}>
            Ahtabot, büronuzda aktif hale geldiği ilk günden itibaren dosyalarınızın Uyap işlemlerini devir alır ve;
        </Typography>
        <Typography variant="body1" gutterBottom>
            <ul className="list">
                <li className="list-item">Uyap ‘taki dosyalarınızın aşama durumlarını tespit eder ve güncel durumlarını günlük/haftalık ve aylık olarak Whatsapp üzerinden raporlar.</li>
                <li>Kimseye sormadan yapılabilecek işlemlerin gereğini kendiliğinden yerine getirerek operasyonlarınızı devam ettirir.
                </li>
                <li>Kullanıcı kararı gerektiren konularda kararınızı sorar, aldığı cevaba göre gereğini yaparak operasyonlarınızı devam ettirir.</li>
                <li>Banka cevap yazıları, iş yeri cevap yazıları, tensip zabıtları ve itiraz belgeleri gibi insan gözü gerektiren belgeleri yapay zeka incelemesine gönderir, sonucunu size onaylatır ve inceleme sonucuna göre operasyonlarınızı devam ettirir.</li>
                <li>Tüm bu işlemleri yaparken kendisine alarmlar kurar, her bir işlemin vakti geldiğinde yapılacağını garanti eder.</li>
                <li>Devam eden işlemleri, sizden cevap beklediği işlemleri, tamamlanan işlemleri günlük/haftalık ve aylık olarak whatsapp üzerinden size raporlar.</li>
            </ul>
        </Typography>

        <Typography component="div" gutterBottom style={{fontsize: 8, fontWeight: "bolder"}}>
            Ahtabot ile;
        </Typography>
        <Typography variant="body1" gutterBottom>
            <ul className="list">
                <li className="list-item">Maliyetleriniz Azalır, Dosyalarınız Hızlı Kapanır, Tahsilatlarınız Artar, Takipleriniz/Hacizleriniz Düşmez, Excel‘lerden Kurtulursunuz</li>
            </ul>
        </Typography>
    </Box>;
}

export default AhtapotTextBox;
